import { useEffect } from "react";
import styles from "../CheckoutSuccess/checkoutsuccess.module.css";
import { PiCheckBold } from "react-icons/pi";
import {
  SubHeadingTitle,
  Button,
  HeadingTitle,
} from "../../../../components/shared/index";

import {
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";

import toast from "react-hot-toast";

const OrderSuccess = () => {

  const location = useLocation();
  const navigate = useNavigate();

  const {
    payment_id,
    payment_method,
    orderId,
    invoice_id,
  } = location.state || {};
// console.log("invoice",invoice_id)
  useEffect(() => {
    window.scrollTo({
      top: 550,
      behavior: "smooth",
    });
  }, []);

  // Prevent direct URL access
  if (!payment_id) {
    toast.error("Order not found");
    return <Navigate to="/shop" replace />;
  }

  return (
    <section className={styles.checkout_success__wrapper}>
      <div className={`${styles.wrapper} ${styles.fade_anim}`}>

        <div className={`${styles.iconWrapper} ${styles.tick_anim}`}>
          <PiCheckBold className={styles.icon} />
        </div>

        <HeadingTitle
          text="Payment Successful 🎉"
          style={styles.title}
        />

        <SubHeadingTitle
          subTitle={`
            Thank you for shopping with us.
          
            ${invoice_id ? ` , Invoice ID: ${invoice_id}` : ""}
          
            ${payment_method ? ` Payment Method: ${payment_method}` : ""}
          `}
          style={styles.subTitle}
        />

        <div className={styles.actions}>

          <Button
            title="Track Order"
            style={styles.trackBtn}
            onHandler={() => navigate("/profile/order")}
          />

          <Button
            title="Continue Shopping"
            style={styles.continueBtn}
            onHandler={() => navigate("/shop")}
          />

          {invoice_id && (
            <Button
              title="Download Invoice"
              style={styles.invoiceBtn}
              onHandler={() =>
                navigate(`/invoice/${invoice_id}`)
              }
            />
          )}

        </div>
      </div>
    </section>
  );
};

export default OrderSuccess;